import styled from 'styled-components';
import { motion } from 'framer-motion';
import { BoxProps, ButtonProps } from 'types';
import { BoxStyles } from '../Box/styles';
import { ButtonStyles } from '../Button/styles';

export const Box = styled(motion.div)<BoxProps>`
	${BoxStyles}
`;
export const Button = styled(motion.div)<ButtonProps>`
	${ButtonStyles}
`;

export const direction = 'vertical';
